var blockquote_default = {
  "fontElementMap": "_1JJZm",
  "quoteContainer": "g8Wtm",
  "quote": "olj1t"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
